export interface PostCSVData {
  id: string;
  title: string;
  post_title: string;
  post_subtitle: string;
  text: string;
  script: string;
  first_question: string;
  second_question: string;
  question: string;
  image_url: string;
  link_url: string;
  thumbnail: string;
  video_url: string;
  youtube_url: string;
  audio_url: string;
  lrc_url: string;
  post_language: string;
  post_type: string;
  category: string;
  tags: string;
  options: string;
  answers: string;
  post_order: number;
}

export const exportPostsToCSV = (
  posts: any[],
  filename: string = 'posts.csv'
) => {
  // Convert posts to CSV format, excluding created_at and updated_at
  const csvData: PostCSVData[] = posts.map(post => ({
    id: post.id || '',
    title: post.attributes?.title || '',
    post_title: post.post_title || '',
    post_subtitle: post.post_subtitle || '',
    text: post.text || '',
    script: post.script || '',
    first_question: post.first_question || '',
    second_question: post.second_question || '',
    question: post.question || '',
    image_url: post.image_url || '',
    link_url: post.link_url || '',
    thumbnail: post.thumbnail || '',
    video_url: post.video_url || '',
    youtube_url: post.youtube_url || '',
    audio_url: post.audio_url || '',
    lrc_url: post.lrc_url || '',
    post_language: post.post_language || '',
    post_type: post.post_type || '',
    category: post.category || '',
    tags: Array.isArray(post.tags) ? post.tags.join(';') : '',
    options: post.options ? JSON.stringify(post.options) : '',
    answers: post.answers ? JSON.stringify(post.answers) : '',
    post_order: post.post_order || 0,
  }));

  // Convert to CSV string
  const headers = Object.keys(csvData[0] || {});
  const csvContent = [
    headers.join(','),
    ...csvData.map(row =>
      headers
        .map(header => {
          const value = row[header as keyof PostCSVData];
          // Escape quotes and wrap in quotes if contains comma, quote, or newline
          const stringValue = String(value || '');
          if (
            stringValue.includes(',') ||
            stringValue.includes('"') ||
            stringValue.includes('\n')
          ) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        })
        .join(',')
    ),
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
